import { PaperLink } from '../types';

/**
 * Serializes a paper link into a unique string.
 * @param link The link to serialize.
 */
export function serializePaperLink(link?: PaperLink) {
  return link ? `${link.id}|${link.slug}` : '';
}

/**
 * Normalizes a serialized paper link.
 * @param link The link to normalize.
 */
export function normalizePaperLink(link: string) {
  const [id, slug] = link.split('|');
  return { id: parseInt(id), slug };
}
